import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import "../../assets/styles/components/gallery.css";


const  GridSkeleton = ({length}) =>(
    <div className="galery_content_container">
      {Array.from(new Array(length)).map((index) => (
        <div key={index} style={{ width: 300 }}>
            <Skeleton className='grid-skeleton' variant="rectangular" />
        </div>
      ))}
    </div>
  );

export default GridSkeleton;
